<template>

<div>
  <div  v-if="isScrolled9">
    <Header/>
  </div>
  <div style="height: 3em;"></div>
  <div style="display: flex;justify-content: center">
    <div>
      <div style="display: flex;justify-content: center">
        <div style="width: 60%">
          <div>
            <div>
              <div style="font-size: larger;text-align: left;margin-top: 20px; width: 60% ">
                <div class="Breadcrumbs">
                  <div class="box">
                    <a href='/' class=''>首页</a> &gt; <a @click="goCase">新闻资讯</a>
                  </div>
                </div>
              </div>
            </div>
            <div >
              <h1 class="title" style="display: flex;justify-content: center;margin: 50px 0;font-size: 2.5em">{{ article.title }}</h1>
              <h3 style="display: flex;justify-content: center;margin: 50px 0;color: gray">{{ formatDate(article.publishTime) }}</h3>
              <div v-html="article.content"></div>
            </div>
          </div>
          <div style="margin:50px 0;text-align: end"> 
            <!-- <Share :sysInfo="article.content" /> -->
          </div>
          <div class="ck">
            <div style="display: flex; justify-content: center; align-items: center;">
              <a @click="goCase">返回列表</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer/>
</div>
</template>

<script>
import Header from "@/views/header.vue";
import Footer from "@/views/footer.vue";
// import Share from "@/views/share.vue";

export default {
  components: {
    // Share,
    Header,
    Footer,
  },
  data() {
    return {
      isScrolled9: true,
      article: {},
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll9);
    
    const articleData = sessionStorage.getItem('articleDetail');
    if (articleData) {
      this.article = JSON.parse(articleData);
      document.title = this.article.title;
    }
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      return new Date(timestamp).toLocaleString();
    },
    goCase(){
      this.$router.push({path:"/case"})
    },
    handleScroll9() {
      const scrollY = window.scrollY || window.pageYOffset;
      const dis = 100;
      if (scrollY > dis) {
        this.isScrolled9 = false;
      } else {
        this.isScrolled9 = true;
      }
    },
  }
};
</script>

<style lang="scss" scoped>

.move1 {
  opacity: 0; 
  animation: fadeIn 1s forwards, moveUp 1.2s forwards; 
}


@keyframes moveUp {
  to {
    transform: translateY(-50px); 
  }
}

@keyframes fadeIn {
  to {
    opacity: 1; 
  }
}

#movingBox {
  transition: transform 0.5s ease; 
}

.bounce-animation {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0); 
  }

  40% {
    transform: translateY(-15px); 
  }

  60% {
    transform: translateY(-15px); 
  }
}

.between{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  background-color: pink;
}
.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;
}
</style>
